class bleUtils {
    constructor() {
        this.device = null;
        this.server = null;
        this.service = null;
    }
    // 在 bleUtils 类中添加以下方法
 // 使用 Promise 化的确认框
 async requestUserConsent(deviceName) {
    return new Promise((resolve, reject) => {
        // 创建自定义确认对话框
        const dialog = document.createElement('div');
        dialog.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 10000;
        `;
        
        dialog.innerHTML = `
            <div style="
                background: white;
                padding: 20px;
                border-radius: 8px;
                text-align: center;
                min-width: 300px;
                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            ">
                <h3>蓝牙连接确认</h3>
                <p>是否连接到蓝牙设备 "${deviceName}"?</p>
                <div style="margin-top: 20px;">
                    <button id="ble-confirm-yes" style="
                        margin: 0 10px;
                        padding: 8px 16px;
                        background: #4CAF50;
                        color: white;
                        border: none;
                        border-radius: 4px;
                        cursor: pointer;
                    ">确定</button>
                    <button id="ble-confirm-no" style="
                        margin: 0 10px;
                        padding: 8px 16px;
                        background: #f44336;
                        color: white;
                        border: none;
                        border-radius: 4px;
                        cursor: pointer;
                    ">取消</button>
                </div>
            </div>
        `;
        
        document.body.appendChild(dialog);
        
        // 确保在用户手势中处理
        const handleYes = () => {
            document.body.removeChild(dialog);
            resolve(true);
        };
        
        const handleNo = () => {
            document.body.removeChild(dialog);
            reject(new Error('用户取消了连接请求'));
        };
        
        // 通过事件监听器绑定，确保在用户手势上下文中执行
        dialog.querySelector('#ble-confirm-yes').addEventListener('click', handleYes);
        dialog.querySelector('#ble-confirm-no').addEventListener('click', handleNo);
    });
}

    async connect(deviceName, SERVICE_UUID, cusOptions = {}) {
        const options = {
            filters: [
                { namePrefix: deviceName },
                { name: deviceName },
            ],
            optionalServices: [SERVICE_UUID],
            ...cusOptions
        }
        try {
              // 请求用户确认
            await this.requestUserConsent(deviceName);
            const device = await navigator.bluetooth.requestDevice(options);
            if (device) {
                const server = await device.gatt.connect();
                const service = await server.getPrimaryService(SERVICE_UUID);
                this.device = device;
                this.server = server;
                this.service = service;

                // Add event listener for disconnect
                device.addEventListener('gattserverdisconnected', () => {
                    console.log('Device disconnected');
                    this.device = null;
                    this.server = null;
                    this.service = null;
                });
                return { device, server, service };
            }
        }
        catch (error) {
            // console.error('Bluetooth connection failed:', error);
            this.device = null;
            this.server = null;
            this.service = null;
            if (!/User cancelled/.test(error.message)) {
                alert(`Failed to connect to ${deviceName}: ${error}`);
            }
            throw error;
        }
    }

    async disConnect(device) {
        if (device && device.gatt.connected) {
            await device.gatt.disconnect();
            console.log('Disconnected from device:', device.name);
            this.device = null;
            this.server = null;
            this.service = null;
            // Remove event listener for disconnect
            device.removeEventListener('gattserverdisconnected', () => {
                console.log('Device disconnected');
                this.device = null;
                this.server = null;
                this.service = null;
            });
        }

    }

    async getCharacteristic(service, characteristicUUID) {
        try {
            const characteristic = await service.getCharacteristic(characteristicUUID);
            return characteristic;
        }
        catch (error) {
            console.error('Failed to get characteristic:', error);
            throw error;
        }
    }

    async writeCharacteristic(characteristic, value) {
        try {
            const data = new Uint8Array(value);
            await characteristic.writeValue(data);
            console.log('Data written to characteristic:', data);
        }
        catch (error) {
            console.error('Failed to write characteristic:', error);
            throw error;
        }
    }
    async writeUint16Characteristic(characteristic, value) {
        try {
            const data = new Uint16Array(value);
            await characteristic.writeValue(data);
            console.log('Data written to characteristic:', data);
        }
        catch (error) {
            console.error('Failed to write characteristic:', error);
            throw error;
        }
    }
    async readCharacteristic(characteristic) {
        try {
            const value = await characteristic.readValue();
            console.log('Data read from characteristic:', value);
            return value;
        }
        catch (error) {
            console.error('Failed to read characteristic:', error);
            throw error;
        }
    }

    async notifyCharacteristic(characteristic, callback) {
        try {
            await characteristic.startNotifications();
            characteristic.addEventListener('characteristicvaluechanged', event => {
                const value = event.target.value;
                callback(value);
            });
            console.log('Notifications enabled for characteristic:', characteristic);
        }
        catch (error) {
            console.error('Failed to enable notifications:', error);
            throw error;
        }
    }

    async stopNotifyCharacteristic(characteristic) {
        try {
            await characteristic.stopNotifications();
            console.log('Notifications disabled for characteristic:', characteristic);
        }
        catch (error) {
            console.error('Failed to disable notifications:', error);
            throw error;
        }
    }

    isConnected(device) {
        return device && device.gatt && device.gatt.connected;
    }

    hex2Buffer(hexstr) {
        let arr = hexstr.match(/.{1,2}/g).map(byte => parseInt(byte, 16));
        let buffer = new Uint8Array(arr)
        return buffer;
    }

    pad(val) {
        const valString = val + '';
        if (valString.length < 2) {
            return '0' + valString;
        } else {
            return valString;
        }
    }

    int2Hex(val, length = 1, smallEnd = false) {
        let num = parseInt(val);
        let hex_str = '';
        let hex_str_length = length * 2;//1个字节=2个16进制字符
        let min = 0;
        let max = 0;
        if (num < 0) {//带符号位
            min = -1 * Math.pow(2, 8 * length - 1);
            max = Math.pow(2, 8 * length - 1) - 1;
            if (num < min || num > max) {//数字超出转换范围
                console.warn(`out of range,min is ${min},max is ${max},but val is ${num}.`)
            } else if (num < 0) {//传入合法负数
                //计算补码
                hex_str = (Math.pow(2, 8 * length) + num).toString(16);
                if (hex_str.length < hex_str_length) {
                    hex_str = 'f'.repeat(hex_str_length - hex_str.length) + hex_str;
                }
            } else {//传入合法正数
                hex_str = num.toString(16);
                if (hex_str.length < hex_str_length) {
                    hex_str = '0'.repeat(hex_str_length - hex_str.length) + hex_str;
                }
            }
        } else {//不带符号位
            min = 0;
            max = Math.pow(2, 8 * length) - 1;
            if (num < min || num > max) {//数字超出转换范围
                console.warn(`out of range,min is ${min},max is ${max},but val is ${num}.`)
            } else {//传入合法正数
                hex_str = num.toString(16);
                if (hex_str.length < hex_str_length) {
                    hex_str = '0'.repeat(hex_str_length - hex_str.length) + hex_str;
                }
            }
        }
        hex_str = hex_str.toUpperCase();
        if (smallEnd) {
            hex_str = reverseHex(hex_str);
        }
        return hex_str;
    }

    hex2float(hexString, precision, bytes = 4) {
        precision = parseInt(precision);
        if (isNaN(precision) || precision < 0) {
            // precision = 2; //默认保留两位小数
            precision = null;
        }
        const hexValue = '0x' + hexString;
        const buffer = new ArrayBuffer(bytes);
        const dataView = new DataView(buffer);
        dataView.setUint32(0, hexValue, false);
        // 从 DataView 中读取浮点数
        const floatValue = dataView.getFloat32(0, false);
        if (precision) {
            return floatValue.toFixed(precision);
        } else {
            return floatValue;
        }
    }
}

export default bleUtils